module.exports = __webpack_public_path__ + "static/media/sarah.7f25cf77.jpg";